import '../Checkbox/styles.scss'
import cx from 'classnames'

interface Props {
  value: string | null
  onChange: (value: string) => void
  options: Array<{
    label: string
    value: string
  }>
  name: string
  className?: string
}

export function RadioButton ({ value, onChange, options, name, className }: Props): JSX.Element {
  function onChangeChecked (_value: string): () => void {
    return () => {
      onChange(_value)
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
      {options.map((option) => (
        <div
          className={cx('nh-checkbox-wrapper', className)}
          key={option.value}
        >
          <div className='nh-checkbox'>
            <input
              className='round'
              checked={value === option.value}
              type='radio'
              name={name}
              onChange={onChangeChecked(option.value)}
              value={option.value}
              required
            />
            <label>{option.label}</label>
          </div>
        </div>
      ))}
    </div>
  )
}
